// ============================================================================
// CONFIRM — canal « confirmation » (§24.1quater A) : question BLOQUANTE posée AVANT une action
// irréversible. Pendant exact de `@orgazone/ui-native/confirm` — signature IDENTIQUE des deux côtés :
// `await confirm(opts) → boolean`. Rendu par `<DialogHost/>` (dialog.tsx).
// ============================================================================
import { type ConfirmTone } from '@orgazone/ui-tokens';
import { pushDialog } from './dialog';

export interface ConfirmOptions {
  /** Nomme la CIBLE et l'AMPLEUR (« Supprimer 3 lignes de fiscal_piece ? ») — jamais un titre vague. */
  title: string;
  /** Conséquence de l'action (ce qui sera détruit / ce qui deviendra impossible). */
  message?: string;
  /** ⚠️ REQUIS : le bouton porte le VERBE de l'action (« Supprimer », « Migrer 4 bases ») — jamais « OK ». */
  confirmLabel: string;
  /** Défaut « Annuler » (tokens). */
  cancelLabel?: string;
  /** `danger` (défaut) = destructif ; `info` = engagement non destructif. */
  tone?: ConfirmTone;
  /**
   * EXIGER LA SAISIE EXACTE DE CE TEXTE avant d'autoriser l'action.
   *
   * ⚠️ POUR CE QUI NE SE RATTRAPE PAS, et rien d'autre. Un clic se donne par réflexe — sur une boîte
   * qu'on a vue dix fois, la main confirme avant que l'œil n'ait lu. Recopier le NOM de la cible est le
   * seul geste qui oblige à REGARDER ce qu'on détruit : on ne recopie pas « MEN FACTORY » en croyant
   * agir sur un autre magasin.
   * ⚠️ Le texte demandé doit être le NOM DE LA CIBLE, jamais un mot rituel du genre « SUPPRIMER » : un
   * mot fixe se tape de mémoire et ne prouve plus rien, alors qu'un nom force à vérifier lequel.
   * ⚠️ Tant qu'il n'est pas saisi, « Entrée » ne confirme pas — sinon la protection tomberait au premier
   * appui machinal.
   */
  requireText?: string;
}

/**
 * Pose la question et rend la main avec la décision : `true` = l'utilisateur a confirmé.
 * Échap/voile = non, Entrée = oui, focus initial sur le bouton d'action — imposés par l'hôte.
 */
export function confirm(opts: ConfirmOptions): Promise<boolean> {
  return pushDialog('confirm', opts);
}
